import { MeshPortalMaterial, Text, useCursor } from "@react-three/drei";
import { extend, MeshProps, ThreeEvent, useFrame } from "@react-three/fiber";
import { easing } from "maath";
import * as geometry from "maath/geometry";
import { ReactNode, useRef, useState } from "react";
import * as THREE from "three";
import { Mesh } from "three";
import { useLocation, useRoute } from "wouter";
extend(geometry);

interface FrameProps extends MeshProps {
  frame_id: string;
  name: string;
  author: string;
  bg: string;
  children: ReactNode;
}

const Frame: React.FC<FrameProps> = ({
  frame_id,
  name,
  author,
  bg,
  children,
  position,
  rotation,
}) => {
  const ref: any = useRef<Mesh>();
  const [, setLocation] = useLocation();
  const [, params] = useRoute("/item/:frame_id");
  const [hovered, hover] = useState(false);
  useCursor(hovered);

  useFrame((_, dt) =>
    easing.damp(
      ref.current,
      "blend",
      params?.frame_id === frame_id ? 1 : 0,
      0.2,
      dt,
    ),
  );

  function nav(event: ThreeEvent<MouseEvent>) {
    event.stopPropagation();
    setLocation("/item/" + event.object.name);
  }

  return (
    <group position={position} rotation={rotation}>
      <Text
        fontSize={0.2}
        anchorY="top"
        anchorX="left"
        lineHeight={0.8}
        position={[-0.375, 0.715, 0.01]}
        material-toneMapped={false}
      >
        {name}
      </Text>
      <Text
        fontSize={0.1}
        anchorX="right"
        position={[0.4, -0.659, 0.01]}
        material-toneMapped={false}
      >
        /{frame_id}
      </Text>
      <Text
        fontSize={0.04}
        anchorX="right"
        position={[0.0, -0.677, 0.01]}
        material-toneMapped={false}
      >
        {author}
      </Text>
      <mesh
        ref={ref}
        name={frame_id}
        onClick={(e) => nav(e)}
        onPointerOver={() => hover(true)}
        onPointerOut={() => hover(false)}
      >
        {/* @ts-ignore */}
        <roundedPlaneGeometry args={[1, 1.65, 0.1]} />
        <MeshPortalMaterial
          ref={ref}
          events={params?.frame_id === frame_id}
          side={THREE.DoubleSide}
        >
          <color attach="background" args={[bg]} />
          {children}
        </MeshPortalMaterial>
      </mesh>
    </group>
  );
};

export default Frame;
